import DeleteConfirmDrawer from "@/components/common/DeleteConfirmDrawer";
import { Drawer } from "@/components/ui/drawer";

interface DeleteTeamDialogProps {
  isOpen: boolean;
  teamName: string;
  onConfirm: () => void;
  onClose: () => void;
}

export default function DeleteTeamDialog({
  isOpen,
  teamName,
  onConfirm,
  onClose,
}: DeleteTeamDialogProps) {
  return (
    <Drawer open={isOpen} onOpenChange={onClose}>
      <DeleteConfirmDrawer
        onConfirm={onConfirm}
        onCancel={onClose}
        name={teamName || "esta equipe"}
        title="Remover Equipe"
        description="Tem certeza que deseja remover esta equipe? Esta ação não pode ser desfeita, e todos os agentes serão removidos da equipe."
      />
    </Drawer>
  );
}
